import { getMeetingForm, getParticipants } from "../services/meetServices";
import { getRoomName } from "../utils/meetingUtils";

export const getAccountId = (getState) => {
    if (getState) {
        return (
            getState().session.defaultAccountId ||
            LocalStorageService.getDefaultAccountId()
        );
    } else {
        return LocalStorageService.getDefaultAccountId();
    }
};

export const getMeetParticipants = (accountId, meetingId) => (dispatch, getState) => {
    return getParticipants(accountId || getAccountId(getState), meetingId)
        .then((response) => {
            return response;
        })
        .catch((error) => error);
};

/**
 * Whether qbrick meet can find this media from its meeting room.
 *
 * Meet has exactly one route from a room to a media: the form that owns the room, through its
 * meetDetails. With no form attached the room resolves to nothing and every live feature in the
 * meeting is silently dead - the live cover, presenter slides, and the notification socket itself,
 * which is gated on having a mediaId. The two conditions below mirror the two places meet gives up.
 *
 * @param {string} mediaId - The media the live manager is working on.
 * @returns {Function} Thunk resolving to true when meet can resolve the media.
 */
export const isMeetFormAttached = (mediaId) => () => {
    const meetingId = getRoomName({ id: mediaId });

    // backendClient.get swallows failures and resolves undefined, so a media with no form at all
    // lands here as a falsy form rather than a rejection.
    return getMeetingForm(meetingId)
        .then((form) =>
            Boolean(
                form?.accountId &&
                    form?.id &&
                    (form.meetDetails ?? []).some((entry) => entry.meetingId === meetingId && entry.mediaId)
            )
        )
        .catch(() => false);
};
